import React from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Stack, Tab, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { selectCurrentUser } from "../shared/sagas/auth/authSlice";
import AdminProfiles from "./components/AdminProfiles";
import AdminCompanies from "./components/AdminCompanies";
import { makeStyles } from "@mui/styles";
import { Role } from "@inosio/payments-sdk";

const useStyles = makeStyles((theme) => ({
  tab: {
    width: 153, 
    minHeight: '38px !important', 
    padding: '0 !important', 
    border: '1px solid #F1F0F5 !important',
    color: '#14142B !important',
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    borderRadius: '4px !important',
    '&.Mui-selected': {
      background: '#F1F0F5 !important',
    },
  },
}));

export default function AdminPortal() {
  const history = useHistory();
  const currentUser = useSelector(selectCurrentUser);
  const classes = useStyles();

  React.useEffect(() => {
    if (!currentUser?.accessToken && !(currentUser?.currentProfile.role && [Role.InosioAdmin, Role.InosioStaff].includes(currentUser?.currentProfile.role))) {
      history.push("/login");
    } else {
      if (currentUser?.currentProfile.role === Role.Resident) {
        history.push("/resui/payments");

        return;
      }
      if (currentUser?.currentProfile?.role === Role.PropertyManager || currentUser?.currentProfile?.role === Role.PropertyManagerAdmin) {
        history.push("/pmui/dashboard");

        return;
      }
    }
  }, [currentUser, history]);

  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Stack sx={{ position: "relative" }}>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "800",
          fontFamily: "Work Sans",
          mt: 4,
          mb: 3,
        }}
      >
        Inosio Admin Portal
      </Typography>
      
      <TabContext value={value}>
        <Grid item display="flex" justifyContent="center" sx={{ mb: 2 }}>
          <Box>
            <TabList onChange={handleChange} sx={{ minHeight: 38, '& .MuiTabs-indicator': { display: 'none' } }}>
              <Tab label="Admin Search" value="1" className={classes.tab} style={{ marginRight: '12px', textTransform: "capitalize" }}/>
              <Tab label="Companies" value="2" className={classes.tab} style={{ textTransform: "capitalize" }} />
            </TabList>
          </Box>
        </Grid>
        <TabPanel value="1" sx={{ padding: 0 }}>
          <AdminProfiles />
        </TabPanel>
        <TabPanel value="2" sx={{ padding: 0 }}>
          <AdminCompanies />
        </TabPanel>
      </TabContext>

    </Stack>
  );
}
